import React, {
  useEffect,
  useState,
} from "react";

import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
  Button,
  Badge,
  Table,
  Input,
} from "reactstrap";

import {
  FiEdit,
  FiTrash2,
  FiBell,
  FiEye,
} from "react-icons/fi";

import api from "../../../utils/api";
import CreateClientModal from "./CreateClientModal";

const Clients = () => {
  const [clients, setClients] =
    useState([]);

  const [stats, setStats] =
    useState({});

  const [modal, setModal] =
    useState(false);

  const [search, setSearch] =
    useState("");

  const loadData =
    async () => {
      try {
        const [
          clientsRes,
          statsRes,
        ] = await Promise.all([
          api.get("superadmin/clients"),
          api.get(
            "superadmin/client-dashboard"
          ),
        ]);

        setClients(
          clientsRes.data || []
        );

        setStats(
          statsRes.data || {}
        );
      } catch (err) {
        console.log(err);
      }
    };

  useEffect(() => {
    loadData();
  }, []);

  const filteredClients =
    clients.filter((client) => {
      const searchText =
        search.toLowerCase();

      return (
        client.propertyName
          ?.toLowerCase()
          .includes(searchText) ||
        client.propertyType
          ?.toLowerCase()
          .includes(searchText) ||
        client.email
          ?.toLowerCase()
          .includes(searchText) ||
        client.mobile
          ?.toLowerCase()
          .includes(searchText)
      );
    });

  const handleEdit = (
    client
  ) => {
    console.log(
      "Edit:",
      client
    );
  };

  const handleDelete = (
    client
  ) => {
    console.log(
      "Delete:",
      client
    );
  };

  const handleNotify = (
    client
  ) => {
    console.log(
      "Notify:",
      client
    );
  };

  return (
    <div className="container-fluid px-4 py-4">
      <Row className="justify-content-center g-4 mb-4">

        <Col xl={3} lg={6} md={6}>
          <Card className="dashboard-card  rounded-4 h-100">
            <CardBody className="text-center">

              <div className="dashboard-icon bg-primary-subtle text-primary">
                <i className="ri-building-2-line"></i>
              </div>

              <h6 className="text-muted mt-3 mb-2">
                Total Clients
              </h6>

              <h2 className="fw-bold mb-0">
                {stats.totalClients || 0}
              </h2>

            </CardBody>
          </Card>
        </Col>

        <Col xl={3} lg={6} md={6}>
          <Card className="dashboard-card  rounded-4 h-100">
            <CardBody className="text-center">

              <div className="dashboard-icon bg-success-subtle text-success">
                <i className="ri-user-star-line"></i>
              </div>

              <h6 className="text-muted mt-3 mb-2">
                Active Clients
              </h6>

              <h2 className="fw-bold text-success mb-0">
                {stats.activeClients || 0}
              </h2>

            </CardBody>
          </Card>
        </Col>

        <Col xl={3} lg={6} md={6}>
          <Card className="dashboard-card  rounded-4 h-100">
            <CardBody className="text-center">

              <div className="dashboard-icon bg-info-subtle text-info">
                <i className="ri-money-rupee-circle-line"></i>
              </div>

              <h6 className="text-muted mt-3 mb-2">
                Total Revenue
              </h6>

              <h2 className="fw-bold text-info mb-0">
                ₹{Number(stats.revenue || 0).toLocaleString()}
              </h2>

            </CardBody>
          </Card>
        </Col>

        <Col xl={3} lg={6} md={6}>
          <Card className="dashboard-card  rounded-4 h-100">
            <CardBody className="text-center">

              <div className="dashboard-icon bg-warning-subtle text-warning">
                <i className="ri-vip-crown-2-line"></i>
              </div>

              <h6 className="text-muted mt-3 mb-2">
                Plans
              </h6>

              <h2 className="fw-bold mb-0">
                3
              </h2>

            </CardBody>
          </Card>
        </Col>

      </Row>
      <Card className=" rounded-4">
        <CardHeader className="bg-white border-0 px-4 pt-4">
          <div className="d-flex justify-content-between align-items-center flex-wrap">

            <div>

              <h4 className="fw-bold mb-1">
                Client Management
              </h4>

              <p className="text-muted mb-0">
                Manage all hotel properties, subscriptions and client accounts.
              </p>

            </div>

            <Button
              color="primary"
              className="rounded-pill px-4"
              onClick={() => setModal(true)}
            >
              <i className="ri-add-circle-line me-2"></i>

              Create Client
            </Button>

          </div>
        </CardHeader>
        <CardBody className="px-4 pb-4">

          <Row className="mb-3">
            <Col md={4}>
              <Input
                placeholder="Search Property, Email, Mobile..."
                value={search}
                onChange={(
                  e
                ) =>
                  setSearch(
                    e.target.value
                  )
                }
              />
            </Col>

            <Col
              md={8}
              className="text-end"
            >
              <span className="text-muted">
                Total Records:
                <strong className="ms-1">
                  {
                    filteredClients.length
                  }
                </strong>
              </span>
            </Col>
          </Row>

          {/* Table */}

          <div className="table-responsive">
         <Table
hover
responsive
className="align-middle table-nowrap"
>
              <thead className="table-light">
                <tr>

                  <th>ID</th>

                  <th>
                    Property Name
                  </th>

                  <th>
                    Type
                  </th>

                  <th>
                    Mobile
                  </th>

                  <th>
                    Admin Email
                  </th>

                  <th>
                    Address
                  </th>

                  <th>
                    Status
                  </th>

                  <th>
                    Plan
                  </th>

                  <th>
                    Start Date
                  </th>

                  <th>
                    End Date
                  </th>

                  <th>
                    Expired In
                  </th>

                  <th>
                    Actions
                  </th>

                </tr>
              </thead>

              <tbody>
                {filteredClients.length ===
                  0 ? (
                  <tr>
                    <td
                      colSpan={9}
                      className="text-center py-4"
                    >
                      No Clients
                      Found
                    </td>
                  </tr>
                ) : (
                  filteredClients.map(
                    (client, index) => (
                      <tr key={client._id}>


                        <td>
                          #
                          {index + 1}
                        </td>


                        <td>
                          <div>
                            <h6 className="mb-0 fw-bold">
                              {client.propertyName}
                            </h6>

                            <small className="text-muted">
                              {client.subdomain}
                            </small>

                          </div>
                        </td>


                        <td>
                          {client.propertyType}
                        </td>


                        <td>
                          {client.mobile}
                        </td>


                        <td>
                          {client.adminEmail}
                        </td>


                        <td>
                          {client.city},
                          <br />
                          {client.state}
                        </td>



                        <td>

                          <Badge
                            color={
                              client.status === "active"
                                ?
                                "success"
                                :
                                "danger"
                            }
                            pill
                          >
                            {client.status}
                          </Badge>

                        </td>



                        <td>

                          <Badge
                            color={
                              client.subscription?.plan === "TRIAL"
                                ?
                                "warning"
                                :
                                "info"
                            }
                            pill
                          >

                            {
                              client.subscription?.plan ||
                              "TRIAL"
                            }

                          </Badge>

                        </td>



                        <td>

                          {
                            client.subscription?.startDate
                              ?
                              new Date(
                                client.subscription.startDate
                              )
                                .toLocaleDateString()
                              :
                              "-"
                          }

                        </td>



                        <td>

                          {
                            client.subscription?.endDate
                              ?
                              new Date(
                                client.subscription.endDate
                              )
                                .toLocaleDateString()
                              :
                              "-"
                          }

                        </td>



                        <td>

                          {

                            client.subscription?.endDate

                              ?

                              Math.max(
                                0,
                                Math.ceil(
                                  (
                                    new Date(
                                      client.subscription.endDate
                                    )
                                    -
                                    new Date()
                                  )
                                  /
                                  (
                                    1000 * 60 * 60 * 24
                                  )
                                )
                              )

                              :
                              "-"

                          }

                          Days

                        </td>



                        <td>


                          <div className="d-flex gap-2">


                            <Button
                              color="primary"
                              size="sm"
                              className="rounded-circle"
                              title="Edit"
                              onClick={() =>
                                handleEdit(client)
                              }
                            >

                              <FiEdit size={16} />

                            </Button>



                            <Button
                              color="danger"
                              size="sm"
                              className="rounded-circle"
                              title="Delete"
                              onClick={() =>
                                handleDelete(client)
                              }
                            >

                              <FiTrash2 size={16} />

                            </Button>



                            <Button
                              color="success"
                              size="sm"
                              className="rounded-circle"
                              title="Notify"
                              onClick={() =>
                                handleNotify(client)
                              }
                            >

                              <FiBell size={16} />

                            </Button>



                            <Button
                              color="info"
                              size="sm"
                              className="rounded-circle"
                              title="View"
                            >

                              <FiEye size={16} />

                            </Button>


                          </div>


                        </td>


                      </tr>

                    ))
                )}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>


      <CreateClientModal
        isOpen={modal}
        toggle={() =>
          setModal(!modal)
        }
        onSuccess={
          loadData
        }
      />
    </div>
  );
};

export default Clients;